import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import TableStructure from "../../CommonComponents/TableStructure";
import { getAllFlipBooksData } from "../../services/FlipBooks";

const FlipBooksTable = () => {
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [sortOrder, setSortOrder] = useState("asc"); // Sorting state
  const session = useSelector((state) => state.session);
  const limit = 50; // Number of records per page

  // Fetch flip books from the API
  const fetchFlipBooks = async (page, term) => {
    setLoading(true);
    try {
      const result = await getAllFlipBooksData(limit, page, term);
      if (result?.data) {
        setRecords(citationFactor(result?.data?.data || []));
        setTotalPages(Math.ceil(result?.data?.total / limit));
        setTotalRecords(result?.data?.total);

        if (result.data.page_number && parseInt(result.data.page_number) !== currentPage) {
          setCurrentPage(parseInt(result.data.page_number));
        }
      }
    } catch (error) {
      console.error("Error fetching flip books:", error);
    } finally {
      setLoading(false);
    }
  };


  const citationFactor = (data) => {
    return data?.map((item) => {
      return {
        imageCount: item?.images?.length || 0,
        masterlist_alias: item?.masterlist_alias,
      }
    })
  }

  const columns = [
    {
      label: "Masterlist Alias",
      accessor: "masterlist_alias",
    },
    {
      label: "No of Pages/Images",
      accessor: "imageCount",
    }
  ]

  // Handle search button click
  const handleSearch = (searchTerm) => {
    if (searchTerm.trim()) {
      isInitialLoad.current = false; // Skip the first render
      setCurrentPage(1); // Reset to page 1 for a new search
      setSearchText(searchTerm);
      fetchFlipBooks(1, searchTerm);
    }
  };

  const sortRecords = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc"; // Update sortOrder first
    setSortOrder(newSortOrder);

    const sorted = [...records].sort((a, b) =>
      newSortOrder === "asc"
        ? a.masterlist_alias.localeCompare(b.masterlist_alias)
        : b.masterlist_alias.localeCompare(a.masterlist_alias)
    );

    setRecords(sorted);
  };

  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false; // Skip the first render
      fetchFlipBooks(currentPage, searchText); // Add this line to fetch on initial load
      return;
    }
    fetchFlipBooks(currentPage, searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleClear = () => {
    setSearchText('');
    fetchFlipBooks(1, "");
  };

  // Handle page changes
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(parseInt(page));
    }
  };

  return (
    <TableStructure
      isAuthenticated={session?.isAuthenticated}
      handleSearch={handleSearch}
      handleClear={handleClear}
      handlePageChange={handlePageChange}
      currentPage={currentPage}
      totalPages={totalPages}
      sortRecords={sortRecords}
      sortOrder={sortOrder}
      loading={loading}
      records={records}
      totalRecords={totalRecords}
      type="flip-books"
      title="Flip Books"
      addOption
      columns={columns}
    />
  );
};

export default FlipBooksTable;
